import { PackageLine } from '@r1-frontend/api-domru/api-tariffs/v1/web/lines';

import { TPackageLine } from '~/src/features/index/MultiPackageList/context/initialState';

import transformPackageLineToMultiPackage from './transformPackageLineToMultiPackage';

const transformApiTariffAnswerToMultiPackage = (packageLines: PackageLine[]): Record<number, TPackageLine> => {
    return packageLines.reduce((acc: Record<number, TPackageLine>, packageLine: PackageLine, index) => {
        if (!Object.keys(packageLine.packages).length) {
            return acc;
        }

        acc[Number(packageLine.id)] = {
            ...transformPackageLineToMultiPackage(packageLine),
            position: index,
        };

        return acc;
    }, {});
};

export default transformApiTariffAnswerToMultiPackage;
